module.exports = "<div class=\"row no-gutters\">\r\n   <div id=\"reCaptchaContainer\"></div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/rw-captcha/template.html
// module id = 1837
// module chunks = 0